/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { useState,useRef,useContext } from 'react'
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick'
import {useSearchParams} from  'react-router-dom'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import Loader from '../../../../../../components/Loader'
import GlobalContext from '../../../../../../components/Context/GloablContext'
import { dataService } from '../../../../../../services/data.services'
export default function ActivityExportPatient({selectedRows,exportObservers,isExportList,exportCols,setIsFilterOpen,isColumnSelect,setIsColumnSelect,isIdexport,username,TotalCount}) {
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage ,isSideBar} = useContext(GlobalContext)
    const [searchParams,setSearchParams]=useSearchParams()
    /* This code is filtering out specific parameters from the `searchParams` object. */
    const excludedParams = ['target_user_name', 'page_number', 'limit'];//this is for activity history export
    const filteredParams = {};
    let queryString
    if(isIdexport){
        for (const [key, value] of searchParams.entries()) {
            if (!excludedParams.includes(key)) {
                filteredParams[key] = value;
            }
        }
        filteredParams["sort"]="timestamp+asc"
        queryString = Object.keys(filteredParams)
            .map(key => `${key}=${encodeURIComponent(filteredParams[key])}`)
            .join('&');

    }
    
    const [exportLoading,setExportLoading]=useState(false)
    
    const [isCheckedAll,setIsCheckedAll] = useState(false)
    const [checkedArr,setCheckedArr] = useState(exportCols)
    const dateformat=useSelector(state=>state.systemConfigData.globalVariables.date_format)
    const ref=useRef()
    function handleIsCheckedAll(){
        setIsCheckedAll(!isCheckedAll)
        if(!isCheckedAll){
            setCheckedArr(exportCols)
        }
        else{
            setCheckedArr([])
        }
        

    }
    async function handleExport(){
        const sort=searchParams?.get("sort")?`${encodeURIComponent(searchParams.get("sort"))}`:queryString
        
        function camelToSnakeCase(str) {
            if(str==="Username"){
                return "user_name"
            }
            else if(str==="Fields"){
                return "field"
            }
            else if(str==="Timestamp"&&isExportList){
                return "created_at"
            }else if(str==='Timestamp'){
                return 'timestamp'
            }
            else if(str==='Filter Name'){
                return 'filters_applied'
            }
            else if(str==='Exported Column Name'){
                return 'exported_columns'
            }
            else if(str==="Old Value"){
                return "old_value"
            }
            else if(str==="New Value"){
                return "new_value"
            }
            else if(str==="Action Performed"){
                return "action"
            }
            else if(str==="Comments"){
                return "comments"
            }
            else{
                return str.replace(/ /g, '_').toLowerCase();
            }
        }
        
        let columns
        if(exportCols.includes('Username')){
            columns=checkedArr.map(camelToSnakeCase)
        }
        setExportLoading(true)
        let payload={}
        let params = Object.fromEntries(searchParams)
        if(params.limit !== ''){
            delete params.limit
        }
        if(params.page_number !== ''){
            delete params.page_number
        }
        isIdexport?payload={sort,columns,username,dateformat,params}:payload={sort,columns,dateformat,params,username}
        
        const exportRes=await exportObservers(payload)
        setExportLoading(false)
        if (TotalCount > 10000) {
            setToastmessage(exportRes?.data?.message);

            let resStatus = await dataService.GetAPI(`access-logs/export-status/${exportRes?.data?.id}`);

            // opening a new window with custom html page with loading screen 
            let myWindow = window.open('', '_blank');

            // the html page injecting to new window
            myWindow.document.write(`
            <!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Export Status</title>
                    <style>
                        body { 
                            font-family: 'Open Sans', sans-serif !important;
                            display: flex; 
                            flex-direction:column;
                            justify-content: center; 
                            align-items: center; 
                            height: 100vh; 
                            margin: 0; 
                            position:relative:
                        }
                        #loading-message { 
                            font-size: 24px; 
                            color: #000; 
                        }
                        .loader {
                            border-top-color: #3498db;
                            -webkit-animation: spinner 1.5s linear infinite;
                            animation: spinner 1.5s linear infinite;
                        }
                        .borderColor{
                            width:50px;
                            height:50px;
                            border-top:4px solid #972E4C;
                            border-radius:50%;
                            margin-bottom:10px;
                        }
                        @-webkit-keyframes spinner {
                            0% {-webkit-transform: rotate(0deg);}
                            100% {-webkit-transform: rotate(360deg);}
                        }

                        @keyframes spinner {
                            0% {transform: rotate(0deg);}
                            100% {transform: rotate(360deg);}
                        }
                    </style>
                </head>
                <body>
                    <div class="loader borderColor"></div>
                    <div id="loading-message">Export is in progress. Please don't close this window.</div>
                </body>
            </html>
        `);

            const checkExportStatus = async () => {
                resStatus = await dataService.GetAPI(`access-logs/export-status/${resStatus?.data?.data?.id}`);
        
                if (resStatus?.data?.data?.message === "Export is in progress. Please wait some time") {
                    //calling the api again if the message is export is in progress
                    setTimeout(checkExportStatus, 20000);
                } else {
                    // if its success showing message and closing the window
                    if (resStatus?.data?.data?.message === "Export completed successfully") {
                        window.open(resStatus?.data?.data?.presigned_url)
                        setToastmessage(resStatus?.data?.data?.message)
                        myWindow.close();
                    }
                }
            };
            // initial api call after the 200ms
            setTimeout(checkExportStatus, 200);
        } 
        else {

            window.open(exportRes?.data?.presigned_url)

        }           
        if(exportRes?.error){
            setToastErrorMessage("Something went wrong")
        }
        else{
            setToastmessage(exportRes?.data?.message)
            
        }
        setIsColumnSelect(!isColumnSelect)
        setCheckedArr(exportCols) 
    }
    useOnClickOutside(ref, () => {
        setIsColumnSelect(false);
    });
    function handleIndividualSelect(column){
        if(checkedArr.includes(column)){
            let filteredArr=checkedArr?.filter((item)=>item!==column)
            setCheckedArr(filteredArr)
            setIsCheckedAll(false)
        }
        else{
            setCheckedArr((prev)=>([
                ...prev,
                column
            ]))

        }
    }
    useEffect(()=>{
        if(checkedArr.length===exportCols.length){
            setIsCheckedAll(true)
        }
        else{
            setIsCheckedAll(false)
        }
    },[checkedArr])
    useEffect(()=>{
        if(isColumnSelect){
            setIsFilterOpen(false)
            setCheckedArr(exportCols)
        }
    },[isColumnSelect])
    return (
        <>
            <button id="icon-export" disabled={selectedRows?.length!==0} onClick={()=>{setIsColumnSelect(!isColumnSelect)}} className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] w-max">
                <img src="/images/download-red.svg" alt="download-icon" />
            </button>
            {isColumnSelect&&
            <motion.div
                initial={{ opacity: 0, x: 80,y:-46 }}
                animate={{ opacity: 1, x: 0 ,y:-46}}
                transition={{ delay: 0.2, duration: 0.5 }}
                exit={{ opacity: 0.5 }}
                className='z-[999] bg-white absolute top-[148px] right-[0px]'
            >
                <div ref={ref} className='border border-[#EEB9BC] rounded rounded-tr-none rounded-br-none pl-3.5 pr-2.5 py-4 shadow-s4 bg-white min-w-[200px]'>
                    <div className='flex items-center justify-between mb-4'>
                        <p className='text-xs font-semibold text-[#031624]'>Select columns to export</p>
                        <button type='button' onClick={()=>setIsColumnSelect(!isColumnSelect)}>
                            <img src="/images/cross_mark_color.svg" alt="icon" />
                        </button>
                    </div>
                    <ul>
                        <li className='flex justify-between items-center mb-4'>
                            <div className="relative checkbox custom-checkBoxBlue1">
                                <input type="checkbox" id='id1' checked={isCheckedAll} onChange={handleIsCheckedAll} className='prevent-click' />
                                <label htmlFor='id1' className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4">All</label>
                            </div>
                            <button onClick={()=>{setCheckedArr([])}} type='button' className={checkedArr?.length===0?'hidden':`text-xs font-semibold text-[#863B50]`}>
                                Clear All
                            </button>
                        </li>
                        <li className='overflow-y-auto 2xl:max-h-max4 max-h-[calc(100vh-452px)] scrollBar-hidden'>
                            <ul>
                                {exportCols.map((column)=>(
                                    <li  key={column} className='mb-4'>
                                        <div  className="relative checkbox custom-checkBoxBlue1">
                                            <input type="checkbox" id={column}  onChange={()=>handleIndividualSelect(column)} checked={checkedArr.includes(column)?true:false}  className='prevent-click' />
                                            <label htmlFor={column} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4">{column}</label>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                    <div className='mt-[46px]'>
                        <button id="Export" onClick={handleExport} disabled={exportLoading||checkedArr.length===0}
                            className={`py-2.5 px-4 flex items-center justify-center text-base font-normal text-[#fff] rounded-[16px] 
           ${exportLoading||checkedArr.length===0?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50]'}  w-full`}>
                            {!exportLoading&&<img src="/images/download_icon_white.svg" alt="icon" />}
                            {exportLoading?<span className='pl-2.5'>{<Loader/>}</span>:<span className='pl-2.5'>Export</span>}
                        </button>
                    </div>
                </div>
            </motion.div>}
        </>
    )
}
